import { ReactComponent as ShirtIcon } from "../../svgs/jersey.svg";
import styles from "./index.module.scss";

export const teamColors = {
  "338": ["#fff", "rgb(46,114,183)"],
  "660": ["rgb(227,119,57)", "#000"],
  "18303": ["rgb(248,206,76)", "#000"],
  "48726": ["rgb(246,224,78)", "#000"],
  "53646": ["rgb(46,88,59)", "#fff"],
  "55686": ["rgb(252,251,84)", "rgb(24,66,104)"],
  "10690": ["#000", "#fff"],
  "63007": ["rgb(69,44,116)", "#fff"],
  "3592": ["#fff", "rgb(192,56,55)"],
  "26459": ["rgb(178, 37, 32)", "#fff"],
  "39097": ["rgb(44,107,67)", "#fff"],
  "48332": ["#fff", "#000"],
  "85465": ["#fff", "rgb(56,120,67)"],
  "84122": ["rgb(202, 152, 192)", "rgb(40, 38, 61)"],
  "81401": ["rgb(215,84,145)", "rgb(246,196,81)"],
  "87883": ["rgb(40,103,197)", "#fff"],
};

const Shirt = ({ age, number, teamId, showAge = true, isSmall = false }) => {
  const tc = teamColors[teamId];

  if (!tc?.length) return null;

  return (
    <div className={styles.view}>
      <div className={styles.shirtCnt}>
        <ShirtIcon
          style={{ fill: tc[0], transform: `scale(${isSmall ? 0.95 : 1.1})` }}
          className={styles.icon}
        />
        <div style={{ color: tc[1] }} className={styles.number}>
          {number}
        </div>
      </div>
      {showAge && <div className={styles.age}>ВІК {age}</div>}
    </div>
  );
};

export default Shirt;
